import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ICredentialsContext, CredentialsContext } from '../../credentialsState/credentialsContext';
import { List } from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Credentials.module.scss';

export const Credentials: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, credentials, currentPage, countOfItems } =
		useContext<ICredentialsContext>(CredentialsContext);

	return (
		<>
			{credentials.count ? (
				<div className={style.container} data-test="Credentials">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={credentials.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
